import NamedDto from 'modules/base/dto/NamedDto';

export class SimulationMonitorLogFieldEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
	}

	/**
	 * @typedef {Object} _SimulationMonitorLogFieldEditDtoProps
	 * @property {string} type
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _SimulationMonitorLogFieldEditDtoProps} SimulationMonitorLogFieldEditDtoProps
	 */
	/**
	 *
	 * @param {SimulationMonitorLogFieldEditDtoProps} props
	 * @returns {SimulationMonitorLogFieldEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		return this;
	}
}

export default SimulationMonitorLogFieldEditDto;
